import { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { RouteConfig } from '../../types';

const MainContainer = ({ children, backgroundColor }) => {
  /** MainContainer styling wrapper */
  const { background } = useStyles();

  useEffect(() => {
    const body: any = document.getElementsByTagName('body')[0];

    body.style.background = backgroundColor ?? 'primary.main';
  }, [backgroundColor]);

  return (
    <Box bgcolor={backgroundColor ?? 'white'}>
      <Box className={background}>{children}</Box>
    </Box>
  );
};

const useStyles = makeStyles(() => {
  return {
    background: {
      width: '100%',
      height: '100%',
      margin: 'auto',
    },
  };
});

export default MainContainer;
